/* SantoLoco ʻiwa surprise: a flock of paper-cutout ʻiwa (great frigatebirds) bursts out of the button,
   with bill clatter, pouch drumming and whistles synthesized in the browser (no audio files). */
(function () {
  if (window.__slIwa) return;
  window.__slIwa = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sky = null, ctx = null, W = 0, H = 0, dpr = 1, fills = null;

  function ensureSky() {
    if (sky) return;
    sky = document.createElement('canvas');
    sky.id = 'sl-iwa-sky';
    sky.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sky);
    ctx = sky.getContext('2d');
    resize();
    window.addEventListener('resize', resize);
    fills = [halftone('#1E1D24', '#3A3946', 6, 1.6), halftone('#18202B', '#33465A', 5, 1.4), halftone('#232020', '#4A4140', 7, 1.9)];
  }
  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth; H = window.innerHeight;
    sky.width = Math.round(W * dpr); sky.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function halftone(bg, dot, size, r) {
    var c = document.createElement('canvas'); c.width = c.height = size;
    var g = c.getContext('2d');
    g.fillStyle = bg; g.fillRect(0, 0, size, size);
    g.fillStyle = dot;
    [[0, 0], [size, 0], [0, size], [size, size], [size / 2, size / 2]].forEach(function (p) { g.beginPath(); g.arc(p[0], p[1], r, 0, Math.PI * 2); g.fill(); });
    return ctx.createPattern(c, 'repeat');
  }

  // ʻIwa (great frigatebird) seen from below, facing +x: long hooked bill, small head, very long narrow wings
  // crooked forward at the wrist and swept back to needle tips, and a long, deeply forked tail.
  // Third value: how much the point moves when the wing flaps (0 = body, 1 = wingtip).
  var HALF = [
    [41,0,0],[39,-1.6,0],[31,-1.3,0],[26,-2.8,0],[21,-3.2,0],[15,-4.6,0],
    [14,-11,.3],[17,-22,.6],[18,-29,.75],[10,-41,.85],[-2,-53,.93],[-24,-72,1],
    [-12,-56,.9],[-4,-44,.8],[-1,-34,.7],[-5,-25,.55],[-7,-15,.35],[-8,-6,.1],
    [-15,-4.4,0],[-23,-3.4,0],[-44,-8.5,0],[-63,-12.5,0],[-45,-5,0],[-31,-1.2,0]
  ];
  var BASE = HALF.concat(HALF.slice(1).reverse().map(function (p) { return [p[0], -p[1], p[2]]; }));
  // Scissors don't cut curves: split long edges into short straight snips, each a little off-line.
  function snip(pts, step, wob) {
    var out = [];
    for (var k = 0; k < pts.length; k++) {
      var a = pts[k], b = pts[(k + 1) % pts.length];
      var dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy);
      var n = Math.max(1, Math.round(len / step));
      for (var j = 0; j < n; j++) {
        var t = j / n, off = j ? (Math.random() - .5) * wob : 0;
        out.push([a[0] + dx * t - dy / len * off, a[1] + dy * t + dx / len * off, a[2] + (b[2] - a[2]) * t]);
      }
    }
    return out;
  }
  function jitter(pts, amt) { return pts.map(function (p) { return [p[0] + (Math.random() - .5) * amt, p[1] + (Math.random() - .5) * amt, p[2]]; }); }
  var PAPERS = ['#1E1D22', '#222A33', '#2B2624', '#1B2220'];

  function makeBird(ox, oy, i, n) {
    var body = jitter(BASE, 1.6), pts = snip(body, 7, 1.1), edge = snip(jitter(BASE, 1.2), 9, 1.6);
    var spread = (i / n) * Math.PI * 2 + (Math.random() - .5) * 0.6;
    var dir = [Math.cos(spread), Math.sin(spread)];
    var far = Math.hypot(W, H) * 0.75 + 120;
    var ex = ox + dir[0] * far, ey = oy + dir[1] * far;
    var bend = (Math.random() < .5 ? -1 : 1) * (120 + Math.random() * 200);
    var mx = (ox + ex) / 2 - dir[1] * bend, my = (oy + ey) / 2 + dir[0] * bend;
    return {
      pts: pts, edge: edge, fill: PAPERS[i % PAPERS.length], male: Math.random() < .5, flag: i === 0,
      patch: jitter([[17,-3.5],[11,-6],[3,-6.5],[-3,-4],[-5,0],[-3,4],[3,6.5],[11,6],[17,3.5]], 1.4),
      pouch: jitter([[24,-2.8],[20,-4.6],[15,-4.4],[12,-2],[12,2],[15,4.4],[20,4.6],[24,2.8]], 1),
      p0: [ox, oy], p1: [mx, my], p2: [ex, ey],
      start: performance.now() + i * 45 + Math.random() * 60,
      dur: reduce ? 2600 : 1300 + Math.random() * 900,
      size: 0.55 + Math.random() * 0.5,
      flapSpeed: 10 + Math.random() * 8, phase: Math.random() * 6.28,
      tilt: (Math.random() - .5) * 0.5
    };
  }
  function bez(b, t) {
    var u = 1 - t;
    var x = u * u * b.p0[0] + 2 * u * t * b.p1[0] + t * t * b.p2[0];
    var y = u * u * b.p0[1] + 2 * u * t * b.p1[1] + t * t * b.p2[1];
    var dx = 2 * u * (b.p1[0] - b.p0[0]) + 2 * t * (b.p2[0] - b.p1[0]);
    var dy = 2 * u * (b.p1[1] - b.p0[1]) + 2 * t * (b.p2[1] - b.p1[1]);
    return [x, y, Math.atan2(dy, dx)];
  }
  function shape(pts, flex) {
    ctx.beginPath();
    pts.forEach(function (p, k) {
      var w = p[2] * flex;
      var yy = p[1] * (1 - 0.3 * w), xx = p[0] + Math.abs(p[1]) * 0.07 * w;
      if (k) ctx.lineTo(xx, yy); else ctx.moveTo(xx, yy);
    });
    ctx.closePath();
  }
  function poly(pts) {
    ctx.beginPath();
    pts.forEach(function (p, k) { if (k) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); });
    ctx.closePath(); ctx.fill();
  }
  // Ka Hae Hawaiʻi: eight stripes (white, red, blue, repeating) with the Union Jack in the canton,
  // laid along the bird so the stripes run across both wings.
  function drawFlag() {
    var top = -76, h = 152 / 8, cols = ['#FFFFFF', '#C8102E', '#012169'];
    for (var k = 0; k < 8; k++) { ctx.fillStyle = cols[k % 3]; ctx.fillRect(-70, top + k * h, 116, h + .4); }
    var cx = -12, cy = -40, cw = 56, ch = 40;   // canton: on the inner wing next to the head
    ctx.save();
    ctx.beginPath(); ctx.rect(cx, cy, cw, ch); ctx.clip();
    ctx.fillStyle = '#012169'; ctx.fillRect(cx, cy, cw, ch);
    ctx.lineCap = 'butt';
    ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = ch * 0.2;
    ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + cw, cy + ch); ctx.moveTo(cx + cw, cy); ctx.lineTo(cx, cy + ch); ctx.stroke();
    ctx.strokeStyle = '#C8102E'; ctx.lineWidth = ch * 0.07;
    ctx.stroke();
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(cx + cw / 2 - ch * 0.17, cy, ch * 0.34, ch); ctx.fillRect(cx, cy + ch / 2 - ch * 0.17, cw, ch * 0.34);
    ctx.fillStyle = '#C8102E';
    ctx.fillRect(cx + cw / 2 - ch * 0.1, cy, ch * 0.2, ch); ctx.fillRect(cx, cy + ch / 2 - ch * 0.1, cw, ch * 0.2);
    ctx.restore();
  }
  function drawBird(b, x, y, ang, scale, flex, alpha) {
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.translate(x, y); ctx.rotate(ang); ctx.scale(scale, scale);
    ctx.lineJoin = 'bevel'; ctx.miterLimit = 2;
    // cream paper margin, cut a little rough, lifted off the page with a crisp shadow
    shape(b.edge, flex);
    ctx.shadowColor = 'rgba(27,26,23,.38)'; ctx.shadowBlur = 2; ctx.shadowOffsetX = 3; ctx.shadowOffsetY = 4;
    ctx.fillStyle = '#F6F1E6'; ctx.strokeStyle = '#F6F1E6'; ctx.lineWidth = 7;
    ctx.stroke(); ctx.fill();
    ctx.shadowColor = 'transparent';
    // the bird itself, cut from dark paper
    shape(b.pts, flex);
    if (b.flag) { ctx.save(); ctx.clip(); drawFlag(); ctx.restore(); }
    else { ctx.fillStyle = b.fill; ctx.fill(); }
    if (b.flag) {}
    else if (b.male) { ctx.fillStyle = '#C9372A'; poly(b.pouch); }   // red throat pouch
    else { ctx.fillStyle = '#EFE9DC'; poly(b.patch); }           // females: white chest
    ctx.fillStyle = '#A39C8E';                                   // pale bill
    poly([[41, 0], [39, -1.3], [29, -1], [29, 1], [39, 1.3]]);
    ctx.restore();
  }

  // ---- sounds ----
  var soundOn = true, ac = null, master = null, noiseBuf = null;
  try { soundOn = localStorage.getItem('iwa-sound') !== 'off'; } catch (e) {}
  function syncSoundButtons() {
    document.querySelectorAll('[data-sl-iwa-sound]').forEach(function (b) { b.setAttribute('aria-pressed', String(soundOn)); });
  }
  // iPhones play web sounds on the 'ringer' channel, which the silent switch mutes.
  // Ask for media playback instead (Safari 17+), and on older iOS unlock it by playing
  // a tiny silent clip inside the tap, which switches the page to the media channel.
  var unlocked = false;
  function silentWav() {
    var n = 800, b = new Uint8Array(44 + n), v = new DataView(b.buffer);
    function str(o, t) { for (var i = 0; i < t.length; i++) b[o + i] = t.charCodeAt(i); }
    str(0, 'RIFF'); v.setUint32(4, 36 + n, true); str(8, 'WAVEfmt '); v.setUint32(16, 16, true);
    v.setUint16(20, 1, true); v.setUint16(22, 1, true); v.setUint32(24, 8000, true); v.setUint32(28, 8000, true);
    v.setUint16(32, 1, true); v.setUint16(34, 8, true); str(36, 'data'); v.setUint32(40, n, true);
    for (var i = 0; i < n; i++) b[44 + i] = 128;
    var bin = ''; for (var j = 0; j < b.length; j++) bin += String.fromCharCode(b[j]);
    return 'data:audio/wav;base64,' + btoa(bin);
  }
  function unlockIOS() {
    if (unlocked) return;
    unlocked = true;
    try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
    try {
      var el = document.createElement('audio');
      el.setAttribute('playsinline', ''); el.setAttribute('x-webkit-airplay', 'deny');
      el.preload = 'auto'; el.loop = false; el.src = silentWav();
      var pr = el.play(); if (pr && pr.catch) pr.catch(function () {});
    } catch (e) {}
  }
  function audio() {
    unlockIOS();
    if (!ac) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ac = new AC();
      var comp = ac.createDynamicsCompressor();
      master = ac.createGain(); master.gain.value = 0.55;
      master.connect(comp); comp.connect(ac.destination);
    }
    if (ac.state === 'suspended') ac.resume();
    return ac;
  }
  function noise() {
    if (!noiseBuf) {
      noiseBuf = ac.createBuffer(1, ac.sampleRate * 0.05, ac.sampleRate);
      var d = noiseBuf.getChannelData(0);
      for (var i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 3);
    }
    return noiseBuf;
  }
  function clatter(t0, count) {
    var t = t0;
    for (var i = 0; i < count; i++) {
      var s = ac.createBufferSource(); s.buffer = noise();
      var bp = ac.createBiquadFilter(); bp.type = 'bandpass';
      bp.frequency.value = 1800 + Math.random() * 1400; bp.Q.value = 6;
      var g = ac.createGain(); g.gain.value = 0.5 + Math.random() * 0.4;
      s.connect(bp); bp.connect(g); g.connect(master);
      s.start(t);
      t += 0.028 + Math.random() * 0.03;
    }
  }
  function drum(t0, dur) {
    var o = ac.createOscillator(); o.type = 'triangle';
    o.frequency.setValueAtTime(150, t0);
    o.frequency.linearRampToValueAtTime(210, t0 + dur * 0.4);
    o.frequency.linearRampToValueAtTime(130, t0 + dur);
    var lp = ac.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 600;
    var pulse = ac.createGain(); pulse.gain.value = 0.5;
    var lfo = ac.createOscillator(); lfo.frequency.value = 18 + Math.random() * 6;
    var depth = ac.createGain(); depth.gain.value = 0.5;
    lfo.connect(depth); depth.connect(pulse.gain);
    var env = ac.createGain();
    env.gain.setValueAtTime(0.0001, t0);
    env.gain.exponentialRampToValueAtTime(0.9, t0 + 0.06);
    env.gain.setValueAtTime(0.9, t0 + dur * 0.7);
    env.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    o.connect(lp); lp.connect(pulse); pulse.connect(env); env.connect(master);
    o.start(t0); lfo.start(t0); o.stop(t0 + dur + 0.05); lfo.stop(t0 + dur + 0.05);
  }
  function whistle(t0, dur, pan) {
    var o = ac.createOscillator(); o.type = 'sine';
    var f = 1700 + Math.random() * 700;
    o.frequency.setValueAtTime(f, t0);
    o.frequency.exponentialRampToValueAtTime(f * 1.15, t0 + dur * 0.25);
    o.frequency.exponentialRampToValueAtTime(f * 0.62, t0 + dur);
    var vib = ac.createOscillator(); vib.frequency.value = 26 + Math.random() * 10;
    var vibAmt = ac.createGain(); vibAmt.gain.value = f * 0.06;
    vib.connect(vibAmt); vibAmt.connect(o.frequency);
    var env = ac.createGain();
    env.gain.setValueAtTime(0.0001, t0);
    env.gain.exponentialRampToValueAtTime(0.22, t0 + 0.04);
    env.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    var out = env;
    if (ac.createStereoPanner) { var p = ac.createStereoPanner(); p.pan.value = pan; env.connect(p); out = p; }
    o.connect(env); out.connect(master);
    o.start(t0); vib.start(t0); o.stop(t0 + dur + 0.05); vib.stop(t0 + dur + 0.05);
  }
  function iwaCall() {
    if (!soundOn || !audio()) return;
    if (ac.state !== 'running') { ac.resume().then(playCall, function () {}); return; }
    playCall();
  }
  function playCall() {
    var t = ac.currentTime + 0.03;
    clatter(t, reduce ? 4 : 9 + Math.floor(Math.random() * 5));
    drum(t + 0.08, 0.55 + Math.random() * 0.25);
    var calls = reduce ? 1 : 2 + Math.floor(Math.random() * 2);
    for (var i = 0; i < calls; i++) whistle(t + 0.25 + i * (0.18 + Math.random() * 0.15), 0.35 + Math.random() * 0.25, (Math.random() * 2 - 1) * 0.8);
  }

  // ---- animation loop ----
  var birds = [], running = false;
  function frame(now) {
    ctx.clearRect(0, 0, W, H);
    birds = birds.filter(function (b) { return now < b.start + b.dur; });
    birds.forEach(function (b) {
      if (now < b.start) return;
      var t = (now - b.start) / b.dur, r;
      if (reduce) {
        r = bez(b, t * 0.25);
        var a = t < .2 ? t / .2 : 1 - (t - .2) / .8;
        drawBird(b, r[0], r[1], r[2], b.size * 0.8, 0, Math.max(0, a));
        return;
      }
      var e = t * t * (1.6 - 0.6 * t);
      r = bez(b, e);
      var glide = Math.sin(now / 1000 * b.flapSpeed + b.phase);
      var flex = t < .35 ? glide : glide * 0.35;
      var scale = b.size * (0.25 + 1.1 * Math.min(1, t * 1.8));
      var wobble = Math.sin(now / 140 + b.phase) * 0.08 + b.tilt;
      drawBird(b, r[0], r[1], r[2] + wobble, scale, flex, 1);
    });
    if (birds.length) requestAnimationFrame(frame); else { running = false; ctx.clearRect(0, 0, W, H); }
  }

  document.addEventListener('click', function (e) {
    var snd = e.target.closest && e.target.closest('[data-sl-iwa-sound]');
    if (snd) {
      soundOn = !soundOn;
      try { localStorage.setItem('iwa-sound', soundOn ? 'on' : 'off'); } catch (err) {}
      syncSoundButtons();
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-sl-iwa]');
    if (!btn) return;
    ensureSky();
    var rect = btn.getBoundingClientRect();
    var ox = rect.left + rect.width / 2, oy = rect.top + rect.height / 2;
    var n = reduce ? 3 : 9 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) birds.push(makeBird(ox, oy, i, n));
    iwaCall();
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
    if (!running) { running = true; requestAnimationFrame(frame); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSoundButtons); else syncSoundButtons();
})();
